import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import 'moment/locale/es';
import moment from 'moment';

import './dateInput.scss';

const locale = "es-ES";
export const DateInput = ({
    onChange,
    label,
    value,
    views = ['year', 'month', 'day'],
    type = 'date',
    disablePast = false,
    disableFuture = false,
    error = false,
    disabled = false,
    required = false,
    className = 'date-input',
    minDate,
    maxDate,
    blockedDates = null,
    allowedDates = null,
}) => {
    const dateValue = value && moment(value)._isValid ? moment(value) : null;
    const DatePicker = type === 'date' ? DesktopDatePicker : DateTimePicker;

    const fixedDate = (val) => {
        return type === 'date'
            ? moment(val).set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
            : moment(val);
    }

    const handleChange = (newDate, context) => {
        if (!newDate || !moment(newDate).isValid() || (context.validationError && moment(newDate).year() > 1000)) return onChange(null);

        // si es solo fecha, fijamos 12:00 para evitar cruces por DST
        const fixed = fixedDate(newDate);

        if (disableFuture && fixed.isAfter(fixedDate(moment()))) return onChange(null);
        if (disablePast && fixed.isBefore(fixedDate(moment()))) return onChange(null);

        onChange(fixed);
    };

    const shouldDisableDate = (date) => {
        const mDate = moment(date);

        // Si se definen allowedDates → solo esas fechas son válidas
        if (allowedDates !== null && allowedDates !== undefined) {
            if (allowedDates.length === 0) return true; // si el array está vacío, se bloquean todas las fechas
            return !allowedDates.some(allowed => mDate.isSame(moment(allowed), 'day'));
        }

        // Si se definen blockedDates → solo esas fechas se bloquean
        if (blockedDates !== null && blockedDates !== undefined) {
            if (blockedDates.length === 0) return false; // si el array está vacío, no se bloquea ninguna fecha
            return blockedDates.some(blocked => mDate.isSame(moment(blocked), 'day'));
        }

        return false;
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale={locale}
            localeText={{
                todayButtonLabel: 'Hoy',
                cancelButtonLabel: 'Cancelar',
                okButtonLabel: 'Aceptar',
            }}>
            <DatePicker
                sx={{ '.MuiPickersSectionList-root': { padding: '8.5px 0' } }}
                disabled={disabled}
                required
                label={`${label} ${required ? '*' : ''}`}
                views={views}
                className={className}
                value={dateValue}
                disablePast={disablePast}
                disableFuture={disableFuture}
                error={error}
                onChange={handleChange}
                minDate={minDate && moment(minDate).isValid() ? moment(minDate) : null}
                minDateTime={(type === 'datetime' && minDate && moment(minDate).isValid()) ? moment(minDate) : null}
                maxDate={maxDate && moment(maxDate).isValid() ? moment(maxDate) : null}
                maxDateTime={(type === 'datetime' && maxDate && moment(maxDate).isValid()) ? moment(maxDate).add(1, 'minute') : null}
                shouldDisableDate={!!dateValue ? null : shouldDisableDate}
                timeSteps={{
                    minutes: 1
                }}
                slotProps={{
                    actionBar: {
                        actions: type === 'datetime' ? ['cancel', 'accept', 'today'] : ['today']
                    }
                }}
            />
        </LocalizationProvider>
    )
};
